export default "__VITE_ASSET__OoRk4FOx__"